<template>
  <div class="ecircular-preview-container email-preview">
    <div class="email-preview__content">
      <ECircularDescriptionView
        v-if="isOldECircularPreview || isVendorEcircular"
        :ecircular="privateECircular"
      />
      <ECircularPreview
        v-else
        :dataSrc="parsedECircular"
      />
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'

import { E_CIRCULAR_STATUS, E_CIRCULAR_TYPES } from '../consts'
import ECircularDescriptionView from './ECircularDescriptionView'
import ECircularPreview from './ECircularPreview'
import { getDepartmentEcTemplateById } from 'api/ecircular/category.request'
import { templateType } from '@/utils/consts'
import { getAttachments } from '@/api/docs/request'
import { ECIRCULAR_TEMPLATE } from '@/pages/department/department.consts'

export default {
  components: {
    ECircularPreview,
    ECircularDescriptionView,
  },
  props: {
    eCircular: {
      type: Object,
      default: undefined,
    },
  },
  data () {
    return {
      templates: [],
      callCenterImgId: null,
    }
  },
  computed: {
    ...mapGetters('ecircular', [
      'currentECircular',
    ]),
    privateECircular () {
      return this.eCircular || this.currentECircular
    },
    isOldECircularPreview () {
      const isOldECircular = this.privateECircular.version === 0
      const shouldUseOldPreviewStatus = [E_CIRCULAR_STATUS.SENT, E_CIRCULAR_STATUS.RESENT].includes(this.privateECircular.status)
      return isOldECircular && shouldUseOldPreviewStatus
    },
    isVendorEcircular () {
      return this.currentECircular.type === E_CIRCULAR_TYPES.VENDOR
    },
    parsedECircular () {
      const result = _.pick(this.privateECircular, ['description', 'signature'])
      const headerRow = this.templates.find(item => item.type === templateType.ECIRCULAR_TENANT_DEPARTMENT_HEADER)
      const footerRow = this.templates.find(item => item.type === templateType.ECIRCULAR_TENANT_DEPARTMENT_FOOTER)
      return Object.assign(result, {
        header: _.get(headerRow, 'content', null),
        footer: _.get(footerRow, 'content', null),
        callCenterImgId: this.callCenterImgId,
      })
    },
  },
  async mounted () {
    if (_.isEmpty(this.privateECircular.templates) && this.privateECircular.categoryId) {
      this.templates = await getDepartmentEcTemplateById(this.privateECircular.categoryId)
      const departmentId = _.get(this.templates, [0, 'sourceId'], null)
      const ref = await getAttachments(departmentId)
      this.callCenterImgId = _.get(ref, [0, 'id'], null)
    } else {
      this.templates = this.privateECircular.templates
      const callCenterImg = this.templates.find(item => item.type === ECIRCULAR_TEMPLATE.ECIRCULAR_TENANT_DEPARTMENT_CALL_CENTER)
      this.callCenterImgId = _.get(callCenterImg, 'id', null)
    }
  },
}
</script>
<style lang="scss" scoped>
@import '~styles/email_preview';
</style>
